import { useMemo } from 'react'
import { useServiceTypes } from '@/hooks/useServiceTypes'
import type { ServiceType } from './LicenseFormSchema'

/**
 * Adapts the shared service-types React Query data (useServiceTypes) to the license form's
 * client-only ServiceType shape (non-null fields). Replaces reads of the legacy
 * member.serviceTypes Redux slice + the getServiceTypes thunk.
 */
export const useLicenseFormServiceTypes = (): ServiceType[] => {
  const { serviceTypes } = useServiceTypes()

  return useMemo(
    () =>
      serviceTypes.map((serviceType) => ({
        ServiceTypeId: serviceType.ServiceTypeId ?? '',
        Name: serviceType.Name ?? '',
        VisitTypes: (serviceType.VisitTypes ?? []).map((visitType) => ({
          VisitTypeId: visitType.VisitTypeId ?? '',
          Name: visitType.Name ?? '',
          VisibilityType: visitType.VisibilityType ?? null,
        })),
      })),
    [serviceTypes],
  )
}
